import { render, staticRenderFns } from "./WidgetListingWatch.vue?vue&type=template&id=21ec2982"
import script from "./WidgetListingWatch.vue?vue&type=script&lang=js"
export * from "./WidgetListingWatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports